module.exports = __webpack_public_path__ + "img/SilentRunning.f550c456.png";